import { defaultFill } from '../utils/constants';
var muiCloseGlyph = {
    paths: [
        {
            path: 'M0.278815829,12.3163126 C-0.0856938079,12.6808223 -0.10305141,13.3317323 0.287494629,13.7135996 C0.669361868,14.0954668 1.32027193,14.086788 1.68478157,13.7222784 L6.9962077,8.40217344 L12.3163126,13.7222784 C12.6895011,14.0954668 13.3317323,14.0954668 13.7135996,13.7135996 C14.086788,13.3230535 14.0954668,12.6895011 13.7135996,12.3163126 L8.40217344,6.9962077 L13.7135996,1.68478157 C14.0954668,1.31159313 14.0954668,0.669361868 13.7135996,0.287494629 C13.3230535,-0.0856938079 12.6895011,-0.0943726087 12.3163126,0.278815829 L6.9962077,5.59892076 L1.68478157,0.278815829 C1.32027193,-0.0856938079 0.660683067,-0.10305141 0.287494629,0.287494629 C-0.0943726087,0.669361868 -0.0856938079,1.32027193 0.278815829,1.68478157 L5.59892076,6.9962077 L0.278815829,12.3163126 Z',
            fill: defaultFill,
        },
    ],
    title: 'Close',
    width: 14,
    height: 14,
};
var muiClose = {
    base: muiCloseGlyph,
};
export { muiClose };
//# sourceMappingURL=close.js.map